import AutoAwesomeIcon from "@mui/icons-material/AutoAwesomeRounded";
import { Avatar } from "@mui/material";
import { makeTintedBackgroundFromColor } from "@entrilia/shared/utilities/colorHelper";

interface AvatarLook {
  size: number;
  iconSize: number;
  borderRadius: string;
}

type AvatarSize = "small" | "medium" | "large";

const avatarLooks: Record<AvatarSize, AvatarLook> = {
  small: { size: 24, iconSize: 14, borderRadius: "50%" },
  medium: { size: 28, iconSize: 18, borderRadius: "8px" },
  large: { size: 52, iconSize: 30, borderRadius: "14px" },
};

interface Props {
  size: AvatarSize;
}

const ArtifactAgentAvatar = ({ size }: Props) => {
  const look = avatarLooks[size];
  return (
    <Avatar
      sx={(t) => ({
        width: look.size,
        height: look.size,
        flexShrink: 0,
        borderRadius: look.borderRadius,
        bgcolor: makeTintedBackgroundFromColor(t, t.palette.primary.main),
        color: t.palette.primary.main,
      })}
    >
      <AutoAwesomeIcon sx={{ fontSize: look.iconSize }} />
    </Avatar>
  );
};

export default ArtifactAgentAvatar;
